import React from "react";

const ImportantChangesNotice = () => (
  <p className="important-changes-notice">
    <strong>Important Changes to Ground Rent Services</strong>{" "}
    <a href="/important-changes">Click here to view</a>
  </p>
);

export default ImportantChangesNotice;
